document.addEventListener("DOMContentLoaded", () => {
  // ==================== MOBILE MENU ====================
 const menuToggle = document.getElementById("menu-toggle");
  const mobileMenu = document.getElementById("mobile-menu");
  const iconOpen = document.getElementById("menu-icon-open");
  const iconClose = document.getElementById("menu-icon-close");

  function closeMobileMenu() {
    if (!mobileMenu || !menuToggle) return;

    mobileMenu.classList.remove("open");
    menuToggle.setAttribute("aria-expanded", "false");
    menuToggle.setAttribute("aria-label", "Open menu");

    if (iconOpen) iconOpen.style.display = "block";
    if (iconClose) iconClose.style.display = "none";
  }

  if (menuToggle && mobileMenu) {

    if (iconOpen) iconOpen.style.display = "block";
    if (iconClose) iconClose.style.display = "none";

    menuToggle.addEventListener("click", () => {

      const isOpen = mobileMenu.classList.contains("open");

      if (isOpen) {
        closeMobileMenu();
      } else {
        mobileMenu.classList.add("open");

        menuToggle.setAttribute("aria-expanded", "true");
        menuToggle.setAttribute("aria-label", "Close menu");

        if (iconOpen) iconOpen.style.display = "none";
        if (iconClose) iconClose.style.display = "block";
      }

    });

    mobileMenu.querySelectorAll("a").forEach((link) => {
      link.addEventListener("click", closeMobileMenu);
    });

  
  }

  // ==================== SIZE BUTTON TOGGLE ====================
  document.querySelectorAll(".size-group").forEach((group) => {
    const buttons = group.querySelectorAll(".size-btn");
    const hiddenInput = group.closest("form").querySelector('input[name="id"]');

    buttons.forEach((btn) => {
      btn.addEventListener("click", () => {
        buttons.forEach((b) => {
          b.classList.remove("active-size");
          b.classList.add("liquid-glass");
        });
        btn.classList.remove("liquid-glass");
        btn.classList.add("active-size");

        if (hiddenInput) {
          hiddenInput.value = btn.dataset.variantId;
        }
      });
    });
  });

  // ==================== SIZE CHART TOGGLE ====================
  document.querySelectorAll(".size-chart-toggle").forEach((toggle) => {
    toggle.addEventListener("click", () => {
      const wrap = toggle.closest(".size-chart-wrap");
      const body = wrap.querySelector(".size-chart-body");
      const icon = wrap.querySelector(".size-chart-icon");
      const isOpen = body.classList.contains("open");
      body.classList.toggle("open", !isOpen);
      icon.classList.toggle("open", !isOpen);
    });
  });

  // ==================== FILM MUTE TOGGLE ====================
  const MUTED_SVG = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M11 5 6 9H3v6h3l5 4V5Z"/><path d="M22 9l-6 6"/><path d="M16 9l6 6"/></svg>`;
  const UNMUTED_SVG = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M11 5 6 9H3v6h3l5 4V5Z"/><path d="M16 9a4 4 0 0 1 0 6"/><path d="M19 6.5a8 8 0 0 1 0 11"/></svg>`;

  document.querySelectorAll(".film-mute-btn").forEach((btn) => {
    btn.addEventListener("click", () => {
      const tile = btn.closest(".film-tile");
      const video = tile ? tile.querySelector("video") : null;
      const muted = btn.getAttribute("data-muted") === "true";
      const next = !muted;
      if (video) {
        video.muted = next;
        if (!next) {
          const p = video.play();
          if (p && p.catch) p.catch(() => {});
        }
      }
      btn.setAttribute("data-muted", String(next));
      btn.setAttribute("aria-label", next ? "Unmute" : "Mute");
      btn.innerHTML = next ? MUTED_SVG : UNMUTED_SVG;
    });
  });

  // ==================== HERO VIDEO FADE-IN ====================
  const heroVideo = document.getElementById("hero-video");
  if (heroVideo) {
    heroVideo.addEventListener("loadeddata", () => {
      heroVideo.style.opacity = "1";
      const p = heroVideo.play();
      if (p && p.catch) p.catch(() => {});
    });
    const p = heroVideo.play();
    if (p && p.catch) p.catch(() => {});
  }

  // ==================== CART DRAWER AJAX LOGIC ====================
  const cartBtn = document.getElementById("cart-btn");
  const cartCloseBtn = document.getElementById("cart-close-btn");
  const cartScrim = document.getElementById("cart-scrim");
  const cartPanel = document.getElementById("cart-panel");
  const cartCountBadge = document.getElementById("cart-count-badge");
  const cartEmptyState = document.getElementById("cart-empty");
  const cartItemsList = document.getElementById("cart-items-list");
  const cartFooter = document.getElementById("cart-footer");
  const cartSubtotal = document.getElementById("cart-subtotal");
  const checkoutBtn = document.getElementById("checkout-btn");

  function fmt(cents) {
    return `$${(cents / 100).toFixed(2)}`;
  }

  function openCart() {
    if (!cartPanel || !cartScrim) return;
    cartPanel.classList.add("open");
    cartScrim.classList.add("open");
    document.body.style.overflow = "hidden";
    fetchAndRenderCart();
  }

  function closeCart() {
    if (!cartPanel || !cartScrim) return;
    cartPanel.classList.remove("open");
    cartScrim.classList.remove("open");
    document.body.style.overflow = "";
  }

  if (cartBtn) cartBtn.addEventListener("click", openCart);
  if (cartCloseBtn) cartCloseBtn.addEventListener("click", closeCart);
  if (cartScrim) cartScrim.addEventListener("click", closeCart);
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && cartPanel && cartPanel.classList.contains("open")) closeCart();
  });

  async function fetchAndRenderCart() {
    try {
      const response = await fetch("/cart.js");
      const cart = await response.json();

      // Upsell Carry Bag check
      const carryBagId = window.carryBagVariantId ? parseInt(window.carryBagVariantId) : null;
      const hasCarryBag = carryBagId ? cart.items.some(item => item.variant_id === carryBagId || item.id === carryBagId) : false;
      const upsellCb = document.getElementById("cart-upsell-checkbox");
      if (upsellCb) {
        upsellCb.checked = hasCarryBag;
      }
      
      const upsellSection = document.getElementById("cart-upsell-section");
      if (upsellSection && carryBagId) {
        const hasOtherItems = cart.items.some(item => item.variant_id !== carryBagId && item.id !== carryBagId);
        upsellSection.style.display = (cart.item_count > 0 && hasOtherItems) ? "block" : "none";
      }

      if (cartCountBadge) {
        cartCountBadge.textContent = cart.item_count > 99 ? "99+" : cart.item_count;
        cartCountBadge.style.display = cart.item_count > 0 ? "flex" : "none";
      }

      if (cart.item_count === 0) {
        if (cartEmptyState) cartEmptyState.style.display = "flex";
        if (cartItemsList) cartItemsList.innerHTML = "";
        if (cartFooter) cartFooter.classList.remove("has-items");
      } else {
        let calculatedSubtotalCents = 0;

        if (cartEmptyState) cartEmptyState.style.display = "none";
        if (cartItemsList) {
          cartItemsList.innerHTML = cart.items
            .map((item) => {
              const isCarryBag = carryBagId && (item.variant_id === carryBagId || item.id === carryBagId);
              const displayCents = isCarryBag ? (400 * item.quantity) : item.final_line_price;
              calculatedSubtotalCents += displayCents;

              return `
            <div class="cart-item-row" data-key="${item.key}">
              <div class="cart-item-img-wrap liquid-glass">
                ${item.image ? `<img src="${item.image}" alt="${item.title}" />` : '<div class="cart-item-img-placeholder"></div>'}
              </div>
              <div class="cart-item-info">
                <div class="cart-item-name">${item.product_title}</div>
                <div class="cart-item-size">${item.variant_options.join(" / ")}</div>
                <div class="cart-item-actions">
                  <div class="cart-qty-picker liquid-glass">
                    <button type="button" class="qty-btn cart-qty-decrease" data-key="${item.key}" data-qty="${item.quantity}" aria-label="Decrease">−</button>
                    <span class="qty-count">${item.quantity}</span>
                    <button type="button" class="qty-btn cart-qty-increase" data-key="${item.key}" data-qty="${item.quantity}" aria-label="Increase">+</button>
                  </div>
                  <button type="button" class="btn-remove-item cart-item-remove" data-key="${item.key}">Remove</button>
                </div>
              </div>
              <div class="cart-item-price-val">${fmt(displayCents)}</div>
            </div>
          `;
            })
            .join("");
        }
        if (cartFooter) cartFooter.classList.add("has-items");
        if (cartSubtotal) cartSubtotal.textContent = fmt(calculatedSubtotalCents);

        document.querySelectorAll(".cart-qty-decrease").forEach((btn) => {
          btn.addEventListener("click", () => updateCartItem(btn.dataset.key, parseInt(btn.dataset.qty) - 1));
        });
        document.querySelectorAll(".cart-qty-increase").forEach((btn) => {
          btn.addEventListener("click", () => updateCartItem(btn.dataset.key, parseInt(btn.dataset.qty) + 1));
        });
        document.querySelectorAll(".cart-item-remove").forEach((btn) => {
          btn.addEventListener("click", () => updateCartItem(btn.dataset.key, 0));
        });
      }
    } catch (e) {
      console.error("Error fetching cart:", e);
    }
  }

  async function updateCartItem(key, qty) {
    try {
      if (cartItemsList) cartItemsList.classList.add("cart-loading-state");
      await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: key, quantity: Math.max(0, qty) }),
      });
      await fetchAndRenderCart();
    } catch (e) {
      console.error("Error updating cart:", e);
    } finally {
      if (cartItemsList) cartItemsList.classList.remove("cart-loading-state");
    }
  }

  document.querySelectorAll("form[action$='/cart/add']").forEach((form) => {
    form.addEventListener("submit", async (e) => {
      e.preventDefault();
      const formData = new FormData(form);

      const addBtn = form.querySelector(".add-to-cart-btn");
      const addBtnText = addBtn ? addBtn.querySelector("span") : null;
      const origText = addBtnText ? addBtnText.textContent : "Add to Cart";

      if (addBtnText) addBtnText.textContent = "Adding...";

      try {
        await fetch("/cart/add.js", { method: "POST", body: formData });
        if (addBtnText) {
          addBtnText.textContent = "Added!";
          setTimeout(() => {
            addBtnText.textContent = origText;
          }, 1800);
        }
        openCart();
      } catch (err) {
        console.error("Error adding to cart:", err);
        if (addBtnText) addBtnText.textContent = origText;
      }
    });
  });

  if (checkoutBtn) {
    checkoutBtn.addEventListener("click", () => {
      window.location.href = "/checkout";
    });
  }

  // ==================== UPSALE CARRY BAG ACTION ====================
  const upsellCheckbox = document.getElementById("cart-upsell-checkbox");
  const upsellSpinner = document.getElementById("cart-upsell-spinner");

  function setUpsellLoading(loading) {
    if (upsellCheckbox) {
      upsellCheckbox.style.display = loading ? "none" : "inline-flex";
      upsellCheckbox.disabled = loading;
    }
    if (upsellSpinner) {
      upsellSpinner.style.display = loading ? "inline-block" : "none";
    }
    if (cartItemsList) {
      if (loading) cartItemsList.classList.add("cart-loading-state");
      else cartItemsList.classList.remove("cart-loading-state");
    }
  }

  if (upsellCheckbox) {
    upsellCheckbox.addEventListener("change", async () => {
      const carryBagId = window.carryBagVariantId ? parseInt(window.carryBagVariantId) : null;
      if (!carryBagId) return;

      setUpsellLoading(true);

      if (upsellCheckbox.checked) {
        try {
          const res = await fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ items: [{ id: carryBagId, quantity: 1 }] }),
          });
          if (res.ok) {
            await fetchAndRenderCart();
          } else {
            upsellCheckbox.checked = false;
            console.warn("Could not add carry bag. Product may be unavailable or draft.");
          }
        } catch (e) {
          upsellCheckbox.checked = false;
          console.error("Error adding carry bag:", e);
        }
      } else {
        try {
          const res = await fetch("/cart/update.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ updates: { [carryBagId]: 0 } }),
          });
          if (res.ok) {
            await fetchAndRenderCart();
          } else {
            upsellCheckbox.checked = true;
            console.warn("Could not remove carry bag.");
          }
        } catch (e) {
          upsellCheckbox.checked = true;
          console.error("Error removing carry bag:", e);
        }
      }

      setUpsellLoading(false);
    });
  }

  fetch("/cart.js")
    .then((res) => res.json())
    .then((cart) => {
      if (cartCountBadge) {
        cartCountBadge.textContent = cart.item_count > 99 ? "99+" : cart.item_count;
        cartCountBadge.style.display = cart.item_count > 0 ? "flex" : "none";
      }
    })
    .catch((e) => console.error("Error checking cart count on load:", e));

  // ==================== SCROLL REVEAL ====================
  if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    const revealEls = document.querySelectorAll("[data-reveal]");
    if ("IntersectionObserver" in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add("in");
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.12 }
      );
      revealEls.forEach((el) => observer.observe(el));
    } else {
      revealEls.forEach((el) => el.classList.add("in"));
    }
  }
});
